import CustomExternalScript from './CustomExternalScript';

export default CustomExternalScript;
